<template>
  <section class="content">
    <modal title="Désactiver un maîtrise"
           v-on:close="doCloseAnyModals"
           v-if="deleteModal === true">
      <user-delete slot="body"
                          v-on:close="doCloseAnyModals"
                          :user="user"></user-delete>
    </modal>

    <modal title="Modifier un maîtrise"
           v-on:close="doCloseAnyModals"
           v-if="updateModal === true">
      <user-form slot="body"
                      v-on:close="doCloseAnyModals"
                      :maitrise-update="user"></user-form>
    </modal>

    <modal title="Supprimer un maîtrise"
           v-on:close="doCloseAnyModals"
           v-if="deleteDefModal === true">
      <user-delete-def slot="body"
                          v-on:close="doCloseAnyModals"
                          :user="user"></user-delete-def>
    </modal>

    <modal title="Créer un maîtrise"
           v-on:close="doCloseAnyModals"
           v-if="createModal === true">
      <user-form slot="body"
                      v-on:close="doCloseAnyModals"></user-form>
    </modal>
    <modal title="Réactiver un utilisateur"
           v-on:close="doCloseAnyModals"
           v-if="reactivateModal === true">
     <user-reactivate slot="body"
                      v-on:close="doCloseAnyModals"
                      :user="user">
                      </user-reactivate>
    </modal>

    <section class="content-toolbar">
      <div class="btn  export-btn btn-primary"
           v-on:click="exportUsers()">Exporter les utilisateurs actifs
      </div>
      <div class="btn btn-primary"
           v-on:click="clickCreate()">Créer un maîtrise
      </div>
    </section>
    <users-list v-on:delete="clickDelete"
                    v-on:edit="clickEdit"
                    v-on:reactivate="clickReactivate"
                    v-on:deleteDef="clickDeleteDef">
    </users-list>
  </section>
</template>
<script>
  import UsersList from './UsersList'
  import UserDelete from './UserDelete'
  import UserDeleteDef from './UserDeleteDef.vue'
  import UserForm from './UserForm'
  import Modal from '../../commons/Modal'
  import UserReactivate from './UserReactivate'
  import {mapState} from 'vuex'

  export default {
    computed: {
      ...mapState([
        'adminUsers',
      ]),
    },
    components: {
      UserReactivate,
      UsersList,
      UserDelete,
      UserDeleteDef,
      UserForm,
      Modal,
    },
    data: function () {
      return {
        deleteModal: false,
        deleteDefModal: false,
        reactivateModal: false,
        updateModal: false,
        createModal: false,
        user: null,
      }
    },
    methods: {
      clickDelete: function (user) {
        this.user = user
        this.deleteModal = true
      },
      clickDeleteDef: function (user) {
        this.user = user
        this.deleteDefModal = true
      },
      clickReactivate: function (user) {
        this.user = user
        this.reactivateModal = true
      },
      clickEdit: function (user) {
        this.user = user
        this.updateModal = true
      },
      clickCreate: function () {
        this.createModal = true
      },
      doCloseAnyModals: function () {
        this.reactivateModal = false
        this.deleteModal = false
        this.deleteDefModal = false
        this.updateModal = false
        this.createModal = false
      },
      exportUsers: function () {
        this.$store.dispatch('generateUsersReporting')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// AdministrationUsers.vue?7b11eca6